/**
 * events (見学会・イベント) の公開ルート定義
 *
 * `lib/middleware/route-registry.ts` から static import される。
 *
 * Edge Runtime 制約:
 * - 純定数 export のみ（関数呼び出し・副作用なし）
 *
 * @see docs/計画/2026-05-09-ICpochipochi-漏れ抽象化.md L-A3
 *
 * 注意: API パスは /api/event/* （単数形）でルーティングされている既存仕様を維持。
 */

export const EVENTS_PUBLIC_PATHS = {
  pages: [] as const,
  apis: [
    '/api/event/saturday-morning',
    '/api/event/daily-summary/og',
  ] as const,
} as const
